import { Define } from '../types'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

async function apiCall(path: string, options: RequestInit = {}) {
  const token = localStorage.getItem(Define.ACCESS_TOKEN)
  const client_id = localStorage.getItem(Define.CHOOSING_CLIENT) || ''
  const company_id = localStorage.getItem(Define.CHOOSING_COMPANY) || ''
  const warehouse_id = localStorage.getItem(Define.CHOOSING_WAREHOUSE) || ''
  const permissionsHeaders = {
    ['Client-Id']: client_id,
    ['Company-Id']: company_id,
    ['Warehouse-Id']: warehouse_id,
  }

  const response = await fetch(`${API_ENDPOINT}${path}`, {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      ...permissionsHeaders,
      Authorization: `Bearer ${token}`,
      'x-build-version': process.env.REACT_APP_BUILD_VERSION,
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

export function getMe() {
  return apiCall('/user/me')
}

export function getAllClientCompanyWarehouses() {
  return apiCall('/warehouse/accessories/client-warehouse-company')
}
